import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  text-align: center;
  padding-bottom: 50px;
`

const Heading = styled.h2`
  font-weight: 600;
  font-size: 25px;
  padding-bottom: 30px;
`

const Content = styled.div`
  color: ${props => props.theme.colors.grey16};
  line-height: 1.5;
`

export default ({ heading, children, ...rest }) => (
  <Container {...rest}>
    <Heading>
      {heading}
    </Heading>
    <Content>
      {children}
    </Content>
  </Container>
)
